import { LoiAndDdNdaExecutionConfig } from '../models/loi-and-dd-nda-execution-config.model';
import { TimelineActionType } from '../models/timeline-action-type.model';
import { TimelineEventStatus } from '../models/enums/timeline-event-status.enum';

interface EventLike {
    status: TimelineEventStatus;
    linkedAction?: {
        actionType: TimelineActionType;
        referenceItemId?: string | null;
        oldReferenceItemIds?: string[] | null;
    } | null;
}

interface SectionDocumentLike {
    id: string;
    sectionId?: string | null;
}

export const getHiddenDdNdaSectionIds = (
    loiAndDdNdaExecutionConfigs: LoiAndDdNdaExecutionConfig[] | undefined,
    events: EventLike[] | undefined,
    documents: SectionDocumentLike[] | undefined,
    isAdmin: boolean
): Set<string> => {
    if (isAdmin) return new Set();

    const isExecutionEventStarted = (events ?? []).some(
        (e) =>
            e.linkedAction?.actionType ===
                TimelineActionType.SellerCustomSelectLoiAndDdNdaTerms &&
            e.status !== TimelineEventStatus.Upcoming
    );
    if (isExecutionEventStarted) return new Set();

    const ddNdaSectionIds = (loiAndDdNdaExecutionConfigs ?? [])
        .map((config) => config.ddNdaSectionId)
        .filter((sectionId): sectionId is string => !!sectionId);

    // The execution action stores its master placeholder document in the DD NDA section
    // the moment the action is configured; it never renders as a row, so it must not
    // reveal the section — only real documents do.
    const executionReferenceDocumentIds = new Set(
        (events ?? [])
            .filter(
                (e) =>
                    e.linkedAction?.actionType ===
                    TimelineActionType.SellerCustomSelectLoiAndDdNdaTerms
            )
            .flatMap((e) => [
                e.linkedAction?.referenceItemId,
                ...(e.linkedAction?.oldReferenceItemIds ?? []),
            ])
            .filter((id): id is string => !!id)
    );

    return new Set(
        ddNdaSectionIds.filter(
            (sectionId) =>
                !(documents ?? []).some(
                    (d) =>
                        d.sectionId === sectionId &&
                        !executionReferenceDocumentIds.has(d.id)
                )
        )
    );
};
